var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/whatsappIconEnabled.596058b5.png","uri@2x": __webpack_public_path__ + "static/media/whatsappIconEnabled.02a2c697.png","uri@3x": __webpack_public_path__ + "static/media/whatsappIconEnabled.f39b368e.png",
    width: 16,
    height: 16
});